import * as Sentry from '@sentry/vue'

const dsn = import.meta.env.VITE_SENTRY_DSN as string
const environment = import.meta.env.VITE_SENTRY_ENV as string
const regexTarget = /^\//

export default function (app: any, router: any) {
  if (dsn && !(environment.includes('localhost'))) {
    Sentry.init({
      app,
      debug: import.meta.env.DEV,
      dsn,
      environment,
      release: __APP_VERSION__,
      integrations: [
        Sentry.browserTracingIntegration(({ router })),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        'localhost',
        '*.pg.com',
        '*.phoenix-graphics.com',
        regexTarget,
      ],
    })
  }
}
